const EDITOR = {
  TOOLBAR: {
    HEADING: 'heading',
    PARAGRAPH: 'paragraph',
    ORDERED_LIST: 'orderedList',
    BULLET_LIST: 'bulletList',
    TASK_LIST: 'taskList',
    TABLE: 'table',
    BLOCKQUOTE: 'blockquote',
    CODE_BLOCK: 'codeBlock',
    BOLD: 'bold',
    ITALIC: 'italic',
    SUBSCRIPT: 'subscript',
    SUPERSCRIPT: 'superscript',
    UNDERLINE: 'underline',
    STRIKE: 'strike',
    HIGHLIGHT: 'highlight',
    TEXT_STYLE: 'textStyle',
    LINK: 'link',
    IMAGE: 'image',
    VIDEO: 'video',
    AUDIO: 'audio',
    IFRAME: 'iframe',
    RIGHT: 'right',
    LEFT: 'left',
    CENTER: 'center',
    JUSTIFY: 'justify',
    HORIZONTAL_RULE: 'horizontalRule',
  },
} as const;

export { EDITOR };
